import { render, staticRenderFns } from "./SuggestionItem.vue?vue&type=template&id=4ebd7318&scoped=true&"
import script from "./SuggestionItem.vue?vue&type=script&lang=js&"
export * from "./SuggestionItem.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionItem.vue?vue&type=style&index=0&id=4ebd7318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebd7318",
  null
  
)

export default component.exports